import React, { useEffect } from "react";
import { LOCALSTORAGES } from "../constants/constant";

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean>(() => {
    if (typeof window !== "undefined") {
      return Boolean(localStorage.getItem(LOCALSTORAGES.TOKEN));
    }
    return false;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAuthenticated(Boolean(localStorage.getItem(LOCALSTORAGES.TOKEN)));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return { isAuthenticated };
};

export default useAuth;
